import type { SalesPerson } from '../../../api/clients';

/** Label for dropdown: name, optional code, optional email (vendedores sin correo are still usable). */
export function formatSalesPersonOptionLabel(sp: SalesPerson): string {
  const name = (sp.name || '').trim() || 'Sin nombre';
  if (sp.id === 'admin') {
    const em = (sp.email || '').trim();
    return em ? `${name} (${em})` : name;
  }
  const code = (sp.code || '').trim();
  const email = (sp.email || '').trim();
  const parts: string[] = [name];
  if (code) parts.push(`(${code})`);
  if (email) parts.push(email);
  return parts.join(' ');
}

/**
 * `creatorSalesPerson` on the order is persisted as email, código, nombre o id.
 * The vendedor `<select>` uses `SalesPerson.id`, so resolve the stored string once vendors load.
 */
export function resolveStoredCreatorSalesPersonToVendorId(
  stored: string,
  people: SalesPerson[],
  opts?: { currentUserEmail?: string | null }
): string {
  const s = String(stored ?? '').trim();
  if (!s) return '';

  if (people.some(p => p.id === s)) return s;

  const lower = s.toLowerCase();
  const byEmail = people.find(
    p => (p.email || '').trim().toLowerCase() === lower
  );
  if (byEmail) return byEmail.id;

  const cu = String(opts?.currentUserEmail ?? '')
    .trim()
    .toLowerCase();
  if (cu && lower === cu && people.some(p => p.id === 'admin')) {
    return 'admin';
  }
  if (lower === 'administrador' && people.some(p => p.id === 'admin')) {
    return 'admin';
  }

  const byCode = people.find(p => (p.code || '').trim() === s);
  if (byCode) return byCode.id;

  const byCodeCi = people.find(
    p => (p.code || '').trim().toLowerCase() === lower
  );
  if (byCodeCi) return byCodeCi.id;

  const byName = people.find(
    p => (p.name || '').trim().toLowerCase() === lower
  );
  if (byName) return byName.id;

  return s;
}
